import { GetOneInvitationInDto, GetOneInvitationOutDto } from '../../../types/invitation.dto'

export const GET_ONE_INVITATION = 'GET_ONE_INVITATION'
export const GET_ONE_INVITATION_SUCCESS = 'GET_ONE_INVITATION_SUCCESS'
export const GET_ONE_INVITATION_ERROR = 'GET_ONE_INVITATION_ERROR'
export const RESET_GET_ONE_INVITATION = 'RESET_GET_ONE_INVITATION'

export interface GetOneInvitation {
  type: typeof GET_ONE_INVITATION
  payload: GetOneInvitationOutDto
}

export interface GetOneInvitationSuccess {
  type: typeof GET_ONE_INVITATION_SUCCESS
  payload: GetOneInvitationInDto
}

export interface GetOneInvitationError {
  type: typeof GET_ONE_INVITATION_ERROR
  payload: string | boolean
}

export interface ResetGetOneInvitation {
  type: typeof RESET_GET_ONE_INVITATION
  payload: null
}

export interface State {
  data: GetOneInvitationInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneInvitation | GetOneInvitationSuccess | GetOneInvitationError | ResetGetOneInvitation
